// extracted by css-extract-rspack-plugin
export default {"games":"qKGX9","my_games_link":"y8vF7","myGamesLink":"y8vF7","my_games_link_label":"Mjy5u","myGamesLinkLabel":"Mjy5u","game":"WnuDy"};